(function () {
  'use strict';

  const BREAKPOINT = 768;
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  let instances = []; // [{ row, swiperEl, blocks, swiper }]

  // ─── Swiper lifecycle ────────────────────────────────────────────────────

  function buildSliders() {
    document
      .querySelectorAll('[data-slider-on-mobile="true"] .layout-panel-flex--row')
      .forEach((row) => {
        if (row._sliderOnMobile) return;
        row._sliderOnMobile = true;

        // Grab direct group-block children only
        const blocks = Array.from(row.querySelectorAll(':scope > .group-block'));
        if (blocks.length < 2) return; // nothing to slide

        // Build swiper scaffold INSIDE the row (row keeps its padding)
        const swiperEl  = Object.assign(document.createElement('div'), { className: 'swiper slider-on-mobile__swiper' });
        const wrapperEl = Object.assign(document.createElement('div'), { className: 'swiper-wrapper' });

        blocks.forEach((block) => {
          const slide = Object.assign(document.createElement('div'), { className: 'swiper-slide' });
          slide.appendChild(block);
          wrapperEl.appendChild(slide);
        });

        swiperEl.appendChild(wrapperEl);

        // Swiper must fill the row width (row may still be flex)
        swiperEl.style.cssText = 'width:100%;min-width:0;';

        row.appendChild(swiperEl);

        const swiper = new Swiper(swiperEl, {
          loop: true,
          autoplay: { delay: 4000, disableOnInteraction: false },
          autoHeight: true,
          on: {
            // Re-measure after first paint in case images load late
            init(swiper) {
              requestAnimationFrame(() => swiper.updateAutoHeight(0));
            },
          },
        });

        instances.push({ row, swiperEl, blocks, swiper });
      });
  }

  function teardownSliders() {
    instances.forEach(({ row, swiperEl, blocks, swiper }) => {
      swiper.destroy(true, true);
      // Return blocks to row before removing the scaffold
      blocks.forEach((block) => row.appendChild(block));
      swiperEl.remove();
      delete row._sliderOnMobile;
    });
    instances = [];
  }

  // ─── Responsive toggle ───────────────────────────────────────────────────

  function sync() {
    if (window.innerWidth <= BREAKPOINT) {
      if (!instances.length) buildSliders();
    } else {
      if (instances.length) teardownSliders();
    }
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });

  // ─── Lazy-load Swiper from CDN ───────────────────────────────────────────

  function loadSwiper(cb) {
    if (window.Swiper) return cb();

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = SWIPER_CSS;
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = SWIPER_JS;
    script.onload = cb;
    script.onerror = () => console.warn('[slider-on-mobile] Failed to load Swiper from CDN.');
    document.head.appendChild(script);
  }

  loadSwiper(sync);
})();